import React from 'react';
import { useTranslation } from 'react-i18next';

export type AlertMessage = {
  messageKey: string;
  isError?: boolean;
};

type MultiMessageAlertProps = {
  messages: AlertMessage[];
  onClose: () => void;
  okMessageKey?: string;
};

const MultiMessageAlert: React.FC<MultiMessageAlertProps> = ({
  messages,
  onClose,
  okMessageKey = 'wf.common.ok',
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="max-w-[80%] rounded-2xl bg-white px-6 py-5 text-center shadow-xl">
        <div className="mb-4 space-y-2">
          {messages.map((message, index) => (
            <p
              key={`${message.messageKey}-${index}`}
              className={`text-base ${
                message.isError ? 'font-semibold text-red-600' : 'text-gray-800'
              }`}
            >
              {t(message.messageKey)}
            </p>
          ))}
        </div>
        <button onClick={onClose} className="px-4 py-1 text-lg font-semibold text-blue-600">
          {t(okMessageKey)}
        </button>
      </div>
    </div>
  );
};

export default MultiMessageAlert;
